// import * as React from "react";
// import Box from "@mui/joy/Box";
// import CircularProgress from "@mui/joy/CircularProgress";
// import { Typography } from "@mui/material";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";

// export default function NotFound() {
//   return (
//     <Box
//       sx={{
//         marginTop: "5rem",
//         display: "flex",
//         gap: 2,
//         alignItems: "center",
//         flexWrap: "wrap",
//         justifyContent: "center",
//       }}
//     >
//       <Typography
//         sx={{
//           fontSize: "2rem",
//           color: "hsl(48  98%  49%)",
//           textAlign: "center",
//         }}
//       >
//         Road Pilot...
//       </Typography>
//       <br />
//       <br />
//       <br />
//       <div>
//         <CircularProgress size="md" />
//       </div>
//     </Box>
//   );
// }
// 
import React, { useEffect, useState } from "react";
import { FaHome, FaHeadset } from "react-icons/fa";


const NotFound = () => {
  useEffect(() => {
    document.title = "404 - Page Not Found";
  }, []);

  const [isFloating, setIsFloating] = useState(true);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const floatInterval = setInterval(() => {
      setIsFloating((prev) => !prev);
    }, 1500);

    const scaleInterval = setInterval(() => {
      setScale((prev) => (prev === 1 ? 1.1 : 1));
    }, 2000);

    return () => {
      clearInterval(floatInterval);
      clearInterval(scaleInterval);
    };
  }, []);

  const [isHovered, setIsHovered] = useState(false);

  return (
    <div>
      <Header />
      <div className="min-h-screen bg-gradient-to-b from-blue-50 to-purple-50 flex items-center font-ubuntu justify-center p-4">
        <div className="text-center transition-all duration-600 ease-out opacity-100 transform translate-y-0">
          <div
            className={`mb-8 transition-transform duration-1000 ease-in-out transform ${
              isFloating ? "translate-y-0" : "-translate-y-4"
            }`}
          >
            <svg
              className="w-64 h-64 mx-auto"
              viewBox="0 0 200 200"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="100"
                cy="100"
                r="50"
                fill="#0cd4a6"
                className="transition-transform duration-1000"
                style={{ transform: `scale(${scale})` }}
              />
              <path
                d="M70 100C70 83.4315 83.4315 70 100 70C116.569 70 130 83.4315 130 100C130 116.569 116.569 130 100 130C83.4315 130 70 116.569 70 100Z"
                stroke="#ffffff"
                strokeWidth="4"
                strokeLinecap="round"
                className="animate-spin"
                style={{ animationDuration: "8s" }}
              />
            </svg>
          </div>

          <h1
            className="text-6xl md:text-8xl font-bold text-[#0cd4a6] mb-4 transition-transform duration-1000 text-center"
            style={{ transform: `scale(${scale})` }}
          >
            404
          </h1>

          <h2 className="text-2xl text-center md:text-3xl font-semibold text-gray-800 mb-4">
            Oops! Lost in Space
          </h2>

          <p className="text-gray-600 mb-8 max-w-md mx-auto">
            Houston, we have a problem! The page you're looking for seems to
            have drifted into a black hole.
          </p>

          <div className="flex flex-col md:flex-row gap-4 justify-center items-center">
            <button
              className="flex items-center gap-2 px-6 py-3 bg-[#0cd4a6] text-white rounded-full font-medium transition-all duration-200 hover:scale-105 active:scale-95 hover:bg-[#0bbd94] focus:outline-none focus:ring-2 focus:ring-[#0cd4a6] focus:ring-offset-2"
              onClick={() => window.location.href = "/"}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <FaHome className="text-xl" />
              Return Home
            </button>

            <button
              className="flex items-center gap-2 px-6 py-3 bg-white text-[#0cd4a6] rounded-full font-medium border-2 border-[#0cd4a6] transition-all duration-200 hover:scale-105 active:scale-95 hover:bg-[#e6f9f5] focus:outline-none focus:ring-2 focus:ring-[#0cd4a6] focus:ring-offset-2"
              onClick={() => window.location.href = "/support"}
            >
              <FaHeadset className="text-xl" />
              Contact Support
            </button>
          </div>

          <div className="mt-12 text-sm text-gray-500">
            <p>Error Code: 404 | Page Not Found</p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NotFound;